import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=1132fa7c&"
import script from "./VTextarea.vue?vue&type=script&lang=js&"
export * from "./VTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VTextarea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports